import { AuthIAMService } from './strategy-pattern-login/auth-iam.service';

import { Injectable, Injector, InjectionToken } from '@angular/core';
import { BehaviorSubject, map, tap } from 'rxjs';
import { Credentials, IAuthStrategy, UsernameAndPassword, Token, UsernameAndPasswordAndProfile } from '../core/interfaces/auth-strategy.interface';
import { Auth2Service } from './strategy-pattern-login/auth2.service';
import { HttpService } from './http-service';
import {ConfigService} from './webFeeder/config.service';
import {AuthService} from '../auth/auth.service';
import {Loggable} from './strategy-pattern-login/loggable';
import {BrokerAuthService} from '../core/services/broker-auth.service';
import {Constants} from '../utils/constants';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import { SaasAuthStrategyService } from '../core/services/saas-auth-strategy.service';
import { Auth1Service } from './strategy-pattern-login/auth1.service';
import { Auth3Service } from './strategy-pattern-login/auth3.service';
import { AuthAdapterService } from './strategy-pattern-login/auth-adapter.service';


export const AUTH_STRATEGY_LOGIN = new InjectionToken<IAuthStrategy>('');

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService implements IAuthStrategy {

  public iLogin: Loggable;
  public iAuthStrategy: IAuthStrategy;

  constructor(
    private _configService: ConfigService,
    private _authGuard: AuthService,
    private _inject: Injector,
    private _httpService: HttpService,
    private _httpClient: HttpClient,
    private _brokerAuthService: BrokerAuthService,
     auth1Service: Auth1Service,
     auth2Service: Auth2Service,
     auth3Service: Auth3Service,
     authIAMService: AuthIAMService,
     authAdapterService: AuthAdapterService,
  ) {
    if (Constants.LOGIN_TYPE.LoginO === this._configService.getLoginTypeEnabled()) {
      this.iLogin = auth1Service;
    } else if (Constants.LOGIN_TYPE.LoginS === this._configService.getLoginTypeEnabled()) {
      this.iLogin = auth2Service;
    } else if (Constants.LOGIN_TYPE.LoginW === this._configService.getLoginTypeEnabled()) {
      this.iLogin = auth3Service;
    } else if (Constants.LOGIN_TYPE.LoginA === this._configService.getLoginTypeEnabled()) {
      this.iLogin = authAdapterService;
    } else if (Constants.LOGIN_TYPE.LoginIAM === this._configService.getLoginTypeEnabled()) {
      this.iLogin = authIAMService;
    } else {
      this.iLogin = null;
    }
    this.iAuthStrategy = this._inject.get(AUTH_STRATEGY_LOGIN);


  }


  private connectedAs = new BehaviorSubject<number>(
    this.checkBrokerAuthentication() ? 2 : 3
  );

  private ConnectionStatus = new BehaviorSubject<number>(
    0
  );
  public url;

  connectedAs$ = this.connectedAs.asObservable();

  ConnectionStatus$ = this.connectedAs.asObservable();

  login(credentials: Credentials<UsernameAndPassword> | Credentials<Token> | Credentials<UsernameAndPasswordAndProfile>) {
    return this.iAuthStrategy.login(credentials);
  }

  loginBroker(username: string, password: string, profile?: any) {
    return this._brokerAuthService.loginBroker(username, password, profile);
  }

  logout(performLogoutRequest = true) {
    if (performLogoutRequest) {
      this.brokerServiceLogout();
    }
    this._authGuard.logout();
  }

  brokerServiceLogin(username: string, password: string, broker: string) {
    // return this.iLogin.brokerServiceLogin(username, password, broker);
    return this._brokerAuthService.brokerServiceLogin(username, password, broker);
  }

  brokerServiceLogout() {
    this.updateWorkspaceSelected(3);
    // return this.iLogin.brokerServiceLogout();
    return this.iAuthStrategy.logout();
  }

  refresh(){
    return this.iAuthStrategy.refresh()
  }

  brokerServiceInternalLogout() {
    this.updateWorkspaceSelected(3);
    return this.iLogin.brokerServiceInternalLogout();
  }

  checkBrokerAuthentication() {
    if (this._configService.getBrokerToken()) {
      return true;
    } else {
      return false;
    }
  }

  updateWorkspaceSelected(data: number) {
    this.connectedAs.next(data);
  }

  recoverPassword(email: string, type: number, client: boolean = true) {
    return this.iAuthStrategy.recoverPassword(email, type, client);
  }

  changePassword(token: string, type: number, newPassword: string, broker: string, product?: string, recoverType?: string) {
    return this.iLogin.changePassword(token, type, newPassword, broker, product, recoverType);
  }

  difusionChangePassword(login: string, oldPassword: string, newPassword: string, isPasswordExpired = false, recoverType?) {
    return this.iAuthStrategy.difusionChangePassword(login, oldPassword, newPassword, isPasswordExpired, recoverType);
  }

  clientRegisterSimulator(username: string, password: string) {
    return this.iLogin.clientRegisterSimulator(username, password);
  }

  resetSignature(signature: string, newSignature: string) {
    return this.iLogin.resetSignature(signature, newSignature);
  }

  forgotSignature(email: string) {
    return this.iLogin.forgotSignature();
  }

  advisorInfo(login?: string) {
    return this.iLogin.advisorInfo(login);
  }

  advisorChangePassword(currentPassword: string, newPassword: string, guid?: string, advisorId?: number) {
    return this.iLogin.advisorChangePassword(currentPassword, newPassword, guid, advisorId);
  }

  validateTokenAdapter() {
    return this.iLogin.validateTokenAdapter();
  }

  getWStoken(){
    return this._httpClient.post(this._configService.getApiWebFeederRest() + 'token/authentication', null, Constants.httpOptions)
  }

  loginWS(guidUser?: string) {
    return this._httpClient
      .get(this._configService.getApiWebFeederRest() +'/services/AuthFast/LoginWS?guidUser=' + guidUser)
      .pipe(map(response => {
        if (response) {
          const json = response;
          return json;
        }
        return [];
      }));
  }

}
